/*
 * @Author: ZhengXiaowei
 * @Date: 2019-01-09 14:06:31
 * @LastEditors: ZhengXiaowei
 * @LastEditTime: 2019-09-18 12:00:29
 * @Description: 阅读器常规操作mixin
 */
/**
 * 阅读器mixin
 */
import { mapGetters, mapActions } from "vuex";

import { Subscribe, SubscribeInChapter } from "../components/dialog";

// import { getweakSubscribeQR } from "@/api";

export const reader = {
  data() {
    return {
      icon: {
        night: require("../assets/阅读器/night.png"),
        sun: require("../assets/阅读器/sun.png")
      }
    };
  },
  computed: {
    bgItem() {
      return this.options.bgColorStyles[this.bgIndex];
    },
    nightStyle() {
      return this.options.nightStyle;
    },
    readerStyle() {
      return this.night
        ? {
            background: this.nightStyle.background,
            minHeight: window.screen.height + "px"
          }
        : {
            background: this.bgItem.background,
            minHeight: window.screen.height + "px"
          };
    },
    readerTitleLineStyle() {
      return this.night
        ? {
            borderColor: this.nightStyle.btnBorder
          }
        : {
            borderColor: this.bgItem.btnBorder
          };
    },
    readerTitleStyle() {
      return this.night
        ? {
            fontSize: this.fontSize + 1 + "px",
            color: this.nightStyle.color
          }
        : {
            fontSize: this.fontSize + 1 + "px",
            color: this.bgItem.color
          };
    },
    readerContentStyle() {
      return this.night
        ? {
            fontSize: this.fontSize + "px",
            color: this.nightStyle.color
          }
        : {
            fontSize: this.fontSize + "px",
            color: this.bgItem.color
          };
    },
    menuStyle() {
      return this.night
        ? {
            color: this.nightStyle.color,
            background: this.nightStyle.btnBackground,
            borderColor: this.nightStyle.btnBorder
          }
        : {
            color: this.bgItem.color,
            background: this.bgItem.btnBackground,
            borderColor: this.bgItem.btnBorder
          };
    },
    systemStyle() {
      return this.night
        ? {
            background: this.nightStyle.background,
            borderColor: this.nightStyle.sysBtnBorder
          }
        : {
            background: this.bgItem.background,
            borderColor: this.bgItem.sysBtnBorder
          };
    },
    authorBoxStyle() {
      return this.night
        ? {
            background: this.nightStyle.authorBackground
          }
        : {
            background: this.bgItem.authorBackground
          };
    },
    authorHandleStyle() {
      return this.night
        ? {
            background: this.nightStyle.authorBackground,
            borderColor: this.nightStyle.authorLineColor
          }
        : {
            background: this.bgItem.authorBackground,
            borderColor: this.bgItem.btnBorder
          };
    },
    authorLineStyle() {
      return this.night
        ? {
            borderColor: this.nightStyle.authorLineColor
          }
        : {
            borderColor: this.bgItem.authorLineColor
          };
    },
    authorColorStyle() {
      return this.night
        ? {
            color: this.nightStyle.color
          }
        : {
            color: "currentColor"
          };
    },
    ...mapGetters("reader", ["fontSize", "night", "bgIndex"])
  },
  methods: {
    subtract() {
      // * 字体减小
      this.font = this.fontSize;
      // * 边界判断
      if (this.font - 1 < this.options.minFontSize) {
        this.$toast("再小就看不到了哦~");
        return;
      }
      this.setReaderOptions({ name: "font", value: this.font - 1 });
    },
    add() {
      // * 字体加大
      this.font = this.fontSize;
      // * 边界判断
      if (this.font + 1 > this.options.maxFontSize) {
        this.$toast("唉呀妈呀，已经不能再大了啊！！");
        return;
      }
      this.setReaderOptions({ name: "font", value: this.font + 1 });
    },
    bgChange(i) {
      // * 修改背景色
      if (this.bgIndex === i) return;
      this.setReaderOptions({ name: "bg", value: i });
      // * 如果处于夜间模式 则切换回来
      if (this.night) this.toggleNight();
    },
    toggleNight() {
      // * 日夜模式切换
      this.setReaderOptions({ name: "night" });
    },
    showSubscribeQrCode() {
      // * 弱关弹窗
      Subscribe();
    },
    showSubscribeQrcodeInChapter(info) {
      const data = {
        TitleImgSrc:
          "https://ycsd-bucket.oss-cn-hangzhou.aliyuncs.com/ycsd_web/images/barcode/mfks-read-title.png",
        Introduction: ["长按识别下方二维码", "热门小说免费看"],
        BarcodeSrc: info.img
      };
      SubscribeInChapter({ data });
    },
    ...mapActions("reader", ["setReaderOptions"])
  }
};
